//* 组件库工具函数
import { utility } from "various-ui";

//* 配置项引入
import { i18nOption } from "./i18n";
import { useRoutes } from "./router";

//* 工具函数
import { resolveRouteOption } from "./router/utils";

//* 类型引入
import type { RouteRecordRaw } from "vue-router";
import type { RouterConfig } from "@nuxt/schema";

//* 路由初始化
const routes: RouteRecordRaw[] = [];
const options = useRoutes();

//* 生成多语言路由
i18nOption.locales.forEach((locale) => {
    //* 路径前缀
    const routePrefix = locale.code == i18nOption.locale ? "" : `/${locale.code}`;
    const routeLanguage = locale.code || i18nOption.locale;

    //* 遍历生成多语言路由
    options.forEach((route) => {
        //* 当route存在name时, 才会生成路由
        if (!route.name) return;
        else {
            //* 路由配置添加
            routes.push(resolveRouteOption(utility.cloneDeep(route), { routePrefix, routeLanguage }));
        }
    });
});

export default <RouterConfig>{
    routes: () => routes,
};
